import { makeStyles } from '@material-ui/core/styles';
import { colors } from 'theme/color-palette';
const {
	PURPLE,
	WHITE,
	LIGHT_PURPLE,
	BLACK,
	DISABLED,
	LIGHT_GREY,
	TOGGLE_ACTIVE,
	FONT_COLOR,
	DARK_PURPLE,
	GREY,
	LIGHT_PURPLE_TOOLTIP
} = colors;

const previewStyle = makeStyles((theme) => ({
	root: {
		display: 'flex',
		'& .MuiPaper-elevation1': {
			boxShadow: 'none'
		}
	},
	appBar: {
		zIndex: 99,
		margin: 0,
		padding: 0,
		boxShadow: `0px 1px 0px 0px ${LIGHT_GREY}`
	},
	toolbar: {
		position: 'relative',
		display: 'flex',
		justifyContent: 'space-between',
		padding: '0px 16px'
	},
	drawer: {
		width: '360px',
		flexShrink: 0
	},
	msgContainer: {
		display: 'flex',
		alignItems: 'center',
		height: '100vh',
		justifyContent: 'center'
	},
	tableContainer: {
		height: '100vh',
		width: '100vw'
	},
	drawerContainer: {
		width: '360px',
		height: '90vh',
		paddingTop: '64px'
	},
	button: {
		borderRadius: '20px !important',
		height: 40,
		minWidth: 112,
		textTransform: 'none',
		'&:hover': {
			backgroundColor: LIGHT_PURPLE
		},
		margin: '0px 8px',
		boxShadow: 'none'
	},
	disabledButton: {
		borderRadius: 20,
		height: 40,
		minWidth: 112,
		textTransform: 'none',
		margin: '0px 8px',
		boxShadow: 'none'
	},
	customButton: {
		borderRadius: 20,
		height: 40,
		width: '84px',
		textTransform: 'none',
		'&:hover': {
			backgroundColor: LIGHT_PURPLE,
			boxShadow: 'none'
		}
	},
	buttonSchedule: {
		background: PURPLE,
		color: WHITE,
		'&:disabled': {
			color: WHITE,
			backgroundColor: DISABLED
		},
		'&:hover': {
			background: DARK_PURPLE
		},
		paddingRight: 16
	},
	buttonSaveDraft: {
		width: 84
	},
	buttonDrop: {
		background: WHITE,
		color: PURPLE,
		width: 36,
		'&:disabled': {
			color: DISABLED,
			backgroundColor: 'transparent',
			border: `1px solid ${DISABLED}`
		},
		border: '1px solid',
		'&:hover': {
			background: TOGGLE_ACTIVE,
			color: PURPLE
		}
	},
	buttonPreview: {
		background: WHITE,
		color: PURPLE,
		padding: '8px 16px 8px 16px',
		'&:disabled': {
			color: DISABLED,
			backgroundColor: 'transparent'
		},
		'&:hover': {
			background: TOGGLE_ACTIVE,
			color: PURPLE
		}
	},
	lockIcon: {
		width: '16px',
		height: '16px',
		color: PURPLE,
		paddingLeft: '8px'
	},
	buttonSave: {
		background: WHITE,
		color: PURPLE,
		'&:disabled': {
			color: DISABLED,
			backgroundColor: 'transparent',
			border: `1px solid ${DISABLED}`
		},
		border: '1px solid',
		'&:hover': {
			background: TOGGLE_ACTIVE,
			color: PURPLE
		}
	},
	dialogWidth: {
		maxWidth: 680
	},
	previewMsg: {
		fontFamily: 'Bogle-Medium',
		fontSize: '22px',
		color: BLACK
	},
	backdrop: {
		zIndex: theme.zIndex.drawer + 1,
		backgroundColor: WHITE,
		color: PURPLE,
		opacity: '0.9 !important'
	},
	luminateIcon: {
		width: '32px',
		height: '32px',
		marginRight: '16px'
	},
	menuItems: {
		color: FONT_COLOR,
		fontSize: '16px',
		'&:hover': {
			background: TOGGLE_ACTIVE
		}
	},
	tourContainer: {
		gap: '40px',
		width: '492px',
		display: 'flex',
		textAlign: 'center',
		alignItems: 'center',
		padding: '40px 24px 0px',
		flexDirection: 'column'
	},
	tourHeader: {
		color: PURPLE,
		fontSize: '24px',
		marginBottom: '24px'
	},
	tourMsg: {
		color: BLACK,
		fontSize: '18px',
		fontWeight: 300,
		fontFamily: 'Bogle-Light !important'
	},
	tourIcon: {
		width: '178px',
		height: '120px'
	},
	tourBtnWrapper: {
		display: 'flex',
		flexDirection: 'column',
		gap: 8
	},
	tourBtn: {
		width: '210px',
		fontSize: '14px',
		padding: '10px 24px',
		borderRadius: '24px',
		'& span': {
			height: '19px'
		}
	},
	tourBtnPrimary: {
		color: WHITE,
		background: PURPLE,
		'&:hover': {
			background: DARK_PURPLE
		}
	},
	tourBtnSecondary: {
		color: PURPLE,
		background: WHITE,
		border: `1px solid ${LIGHT_GREY}`,
		'&:hover': {
			background: WHITE
		}
	},
	tabsIndicator: {
		height: 4,
		borderRadius: [[100, 100, 0, 0]],
		color: GREY,
		width: '160px !important'
	},
	tabsRoot: {
		borderBottom: `1px solid #E3E4E5`,
		minHeight: 22,
		height: 37,
		width: (P) => `${P.show ? 'calc(100vw - 420px)' : 'calc(100vw - 60px)'}`,
		margin: '0 30px',
		marginTop: '30px'
	},
	tabRoot: {
		color: GREY,
		textTransform: 'capitalize !important',
		minHeight: 22,
		marginRight: 24,
		fontFamily: 'Bogle-Regular !important',
		fontSize: '16px !important',
		height: '100% !important'
	},
	draftName: {
		fontFamily: 'Bogle-Medium',
		fontSize: '20px',
		color: GREY
	},
	templateName: {
		fontFamily: 'Bogle-Medium',
		fontSize: '14px',
		color: GREY,
		marginTop: '4px'
	},
	saveReportIcon: { width: 12 },
	previewReportIcon: { width: 14, height: 10 },
	createReportIcon: { width: 12, marginLeft: 14 },
	saveExitIcon: {
		width: 15,
		marginRight: 10
	},
	tooltip: {
		background: LIGHT_PURPLE_TOOLTIP,
		color: FONT_COLOR,
		width: '328px',
		marginTop: '16px'
	},
	arrow: {
		color: LIGHT_PURPLE_TOOLTIP,
		fontSize: '24px'
	},
	tooltipContainer: {
		display: 'flex',
		alignItems: 'center'
	},
	visibilityIcon: {
		height: '14px',
		width: '14px',
		color: PURPLE
	},
	tooltipHeader: {
		fontSize: '14px',
		color: PURPLE,
		fontWeight: '700',
		marginLeft: '8px',
		display: 'flex',
		flex: 1
	},
	tooltipContent: {
		fontSize: '12px'
	},
	tooltipBtn: {
		width: '80px',
		height: '24px',
		marginTop: '8px',
		marginBottom: '4px',
		fontSize: '12px',
		pointerEvents: 'auto',
		color: WHITE,
		background: PURPLE,
		borderRadius: '20px',
		'&:hover': {
			background: `${DARK_PURPLE} !important`
		}
	},
	searchReport: {
		paddingLeft: '24px',
		display: 'flex',
		justifyContent: 'flex-start'
	},
	newReport: {
		paddingRight: '24px',
		display: 'flex',
		justifyContent: 'flex-end'
	},
	newReportBasic: {
		paddingRight: '24px',
		paddingTop: '40px',
		display: 'flex',
		justifyContent: 'flex-end'
	},
	searchReportBasic: {
		paddingLeft: '24px',
		paddingTop: '40px',
		display: 'flex',
		justifyContent: 'flex-start'
	},
	bullet: {
		position: (P) => (P.isSmallScreen ? 'absolute' : 'relative'),
		marginLeft: '4px'
	},
	dialogboxList: {
		paddingLeft: 16,
		'&>:not(:first-child)': {
			marginTop: 16
		}
	}
}));

export default previewStyle;
